export class User {
  constructor(private id?: number,
              private username?: string,
              private password?: string,
              private groupid?: number,
              private organiserid?: number,
              public email?: string,
              private created?: Date,
              private modified?: Date,
              private verificationCode?: string,
              private isVerified?: boolean,
              private tokenId?: string) {
  }
}
